import { PartialType, PickType } from '@nestjs/swagger';
import { BoardPurchaseUpdatableInterface } from '../interfaces/board-purchase-floor-update.interface';
import { BoardPurchaseFloorDto } from '../dto/board-purchase-floor.dto';

export class BoardPurchaseFloorUpdateDto
  extends PartialType(PickType(BoardPurchaseFloorDto, ['quantity']))
  implements BoardPurchaseUpdatableInterface {}
